import { FormInstance } from "antd";
import * as dc from "@/components/layout/list/defaultType";
import { DataColumnRecord, DataCommonInputParams, DataInputCommonParams } from "../input/inputType";
import { RefObject } from "react";
import { TransitionType } from "../layoutType";
import { convertFormValues, defaultFloatFomatter, focusFormField, getNumber, runFormFunction, setFormClass } from "../input/inputFunction";
import dayjs from "dayjs";
import { getIntArray } from "@/util/arrayutil";
import { Debug } from "@/util/debug";
import { AuthDataType } from "@/components/layout/list/defaultType";
import { enLocale, koLocale } from "@/i18n/routing";
import { getTimelineShowTimeObject } from "../input/timelineChart";
import { checkEmpty } from "@/util/stringutil";
export const brewingCount = 10;
const brewing_step_str = "brewing_step";
const brewing_series = ["calc", "mass_disp"];
const brewing_series_ex = ["bar", "flux"];
const getBrewingChartShowTime = () => {
  const result: Record<string, Record<string, string>> = {};
  getIntArray(brewingCount, 1).forEach((i) => {
    result[brewing_step_str + i + "_term"] = {
      ...getTimelineShowTimeObject(["calc"], brewing_step_str + (i - 1)),
      ...getTimelineShowTimeObject(["mass_disp"], brewing_step_str + (i - 1) + "_end"),
      ...getTimelineShowTimeObject(["result"], brewing_step_str + i + "_calc"),
      ...getTimelineShowTimeObject(brewing_series_ex, brewing_step_str + i),
    };
    result[brewing_step_str + i + "_pourover_calc"] = { ...getTimelineShowTimeObject(brewing_series, brewing_step_str + i) };
    result[brewing_step_str + i + "_pourover_calc_end"] = { ...getTimelineShowTimeObject(["mass_disp"], brewing_step_str + i + "_end") };
  });
  result["brewing_term"] = { calc: "brewing_term_calc", result: "brewing_mass", bar: "brewing_term_bar", flux: "brewing_term_flux" };

  Debug("getBrewingChartShowTime : ", result);
  return result;
};
const checkChange: DataCommonInputParams | undefined = { display: "change" };
const brewingTimers = [
  "brewing_step1_term",
  "brewing_step2_term",
  "brewing_step3_term",
  "brewing_step4_term",
  "brewing_step5_term",
  "brewing_step6_term",
  "brewing_step7_term",
  "brewing_step8_term",
  "brewing_step9_term",
  "brewing_step_end_term",
  "brewing_term",
];

const brewingTimerClear = (formMemo: Record<string, any> | undefined) => {
  if (formMemo) {
    brewingTimers.forEach((term) => {
      if (formMemo[term] && formMemo[term].now) {
        delete formMemo[term].now;
      }
    });
  }
};

const brewingTimerStart = (
  form: FormInstance<any> | undefined,
  formMemo: Record<string, any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  e: any,
  brewing_start_time: boolean,
  setTimer: Function | undefined,
) => {
  if (setTimer) {
    if (e && e.value) {
      if (form) {
        const setValues: Record<string, any> = {};
        const setdate = form.getFieldValue("cupnote_date");
        if (brewing_start_time) {
          setValues.brewing_start_time = e.value;
        }
        if (!setdate && e.value !== undefined) {
          setValues["cupnote_date"] = e.value;
          // form.current.setFieldValue("cupnote_date", e.value);
        }
        setValues["brewing_step1_term"] = dayjs(0).add(-dayjs().utcOffset() * 60000);
        form.setFieldsValue(setValues);
        runFormFunction(formFunction, "brewing_step1_term", "setNow", dayjs());
      }
      setTimer({
        timer: dc.brewingTimer,
        start: e.value,
        form: { form: form, timers: brewingTimers, chart: "timeline_chart", formFunction: formFunction },
      });
    } else {
      setTimer({ timer: dc.brewingTimer, start: undefined });
      brewingTimerClear(formMemo);
    }
  }
};

const getBrewingStepArr = (str: string | string[]): string[] => {
  if (str instanceof Array) {
    const result: string[] = [];
    str.forEach((value) => {
      getIntArray(brewingCount - 1, 1).map((i) => {
        result.push(brewing_step_str + i + value);
      });
    });
    Debug(result);
    return result;
  } else {
    return getIntArray(brewingCount - 1, 1).map((i) => {
      return brewing_step_str + i + str;
    });
  }
};

export const getBrewingStep = (max: number, beaninfo: boolean, onChange: (e: any) => void): DataColumnRecord => {
  const result: DataColumnRecord = {};
  for (let i = 1; i < max; i++) {
    result[brewing_step_str + i] = {
      itemClassName: "brewing_result step_detail next-hidden",
      labelClassName: dc.mobileHidden,
      valueClassName: "flex-col md:flex-row mobile_multi flex-wrap" + (i < max - 1 ? " MobileBrewingDetailUnderLine" : ""), //
      read: beaninfo
        ? undefined
        : {
            display: "notNull",
            displayCheckIds: [brewing_step_str + i + "_term", brewing_step_str + i + "_mass"],
          },
      fieldId: {},
    };
    const tempFieldId = result[brewing_step_str + i].fieldId;
    if (tempFieldId && typeof tempFieldId !== "string") {
      const mainStr = brewing_step_str + i + "_main";
      const mainFieldId: DataInputCommonParams = { fieldId: {}, flexClassName: "brewing_main" };

      if (mainFieldId.fieldId !== undefined && typeof mainFieldId.fieldId !== "string") {
        mainFieldId.fieldId[brewing_step_str + i + "_term"] = { ...dc.brewingStepTimer, onChange: onChange };
        mainFieldId.fieldId[brewing_step_str + i + "_calc"] = { ...dc.brewingMassCalc, saveData: false, readInputDisabled: false };
        mainFieldId.fieldId[brewing_step_str + i + "_mass_calc"] = {
          ...dc.brewingMass,
          saveData: false,
          readInputDisabled: false,
          readOnly: true,
          inputClassName: dc.brewingMass.inputClassName + " brewing_mass_calc",
          edit: { display: false },
        };
        mainFieldId.fieldId[brewing_step_str + i + "_mass"] = {
          ...dc.brewingMass,
          inputClassName: dc.brewingMass.inputClassName + " brewing_mass",
          onChange: onChange,
        };
        mainFieldId.fieldId[brewing_step_str + i + "_mass_disp"] = {
          ...dc.brewingMassCalc,
          inputClassName: dc.inputNumberClassName + " hidden",

          saveData: false,
          readInputDisabled: false,
        };
      }
      const subEspFieldId: DataInputCommonParams = {
        fieldId: {},
        flexClassName: "brewing_sub brewing_detail ml-0 md:ml-2 mt-2 md:mt-0",
        read: beaninfo
          ? { display: true }
          : {
              display: "notNull",
              displayCheckIds: [
                brewing_step_str + i + "_bar",
                brewing_step_str + i + "_flux",
                brewing_step_str + i + "_result",
                brewing_step_str + i + "_pourover",
              ],
            },
      };
      const subEspStr = "brewing_step" + i + "_sub_esp";
      if (subEspFieldId.fieldId !== undefined && typeof subEspFieldId.fieldId !== "string") {
        subEspFieldId.fieldId[brewing_step_str + i + "_pourover"] = {
          ...dc.brewingStepTimer,
          inputClassName: dc.brewingStepTimer.inputClassName + " brewing_drip",
          placeholder: "brewing_pourover",
          onChange: onChange,
          read: beaninfo
            ? undefined
            : {
                display: "notNull",
                displayCheckIds: getBrewingStepArr("_pourover"),
              },
        };

        subEspFieldId.fieldId[brewing_step_str + i + "_result"] = {
          ...dc.brewingMass,
          inputClassName: dc.inputNumberClassName + " brewing_step_result",
          // read: { ...dc.brewingMass.read, variant: "borderless" },
          placeholder: "brewing_mass",
          tooltip: "brewing_mass",
          onChange: onChange,
        };

        subEspFieldId.fieldId[brewing_step_str + i + "_bar"] = {
          ...dc.brewingBar,
          noItem: false,
          inputClassName: dc.brewingBar.inputClassName + " brewing_espresso",
          onChange: onChange,
        };
        subEspFieldId.fieldId[brewing_step_str + i + "_flux"] = {
          ...dc.brewingFlux,
          noItem: false,
          inputClassName: dc.brewingFlux.inputClassName + " brewing_espresso",
          onChange: onChange,
        };
      }

      // const subDripFieldId: DataInputCommonParams = {
      //   fieldId: {},
      //   flexClassName: "brewing_sub brewing_detail brewing_drip mt-2 md:ml-2 md:mt-0",
      //   read: { display: "notNull", displayCheckIds: ["brewing_step" + i + "_pourover"] },
      // };
      // const subDripStr = "brewing_step" + i + "_sub_drip";
      // if (subDripFieldId.fieldId !== undefined && typeof subDripFieldId.fieldId !== "string") {
      // }

      const subBrFieldId: DataInputCommonParams = {
        fieldId: {},
        flexClassName: "brewing_sub brewing_detail brewing_comment_br flex_br",
      };
      const subBrStr = "brewing_step" + i + "_sub_br";
      if (subBrFieldId.fieldId !== undefined && typeof subBrFieldId.fieldId !== "string") {
        // subBrFieldId.fieldId["brewing_step" + i + "_br"] = dc.inputFull;
      }

      const subCommentStr = "brewing_step" + i + "_sub_comment";
      const subCommentFieldId: DataInputCommonParams = {
        fieldId: {},
        flexClassName: "brewing_sub brewing_detail brewing_comment w-full",
        read: beaninfo ? { display: true } : { display: "notNull", displayCheckIds: [brewing_step_str + i + "_comment"] },
      };
      if (subCommentFieldId.fieldId !== undefined && typeof subCommentFieldId.fieldId !== "string") {
        subCommentFieldId.fieldId[brewing_step_str + i + "_comment"] = {
          ...dc.inputFull,
          inputClassName: "mt-2",
          placeholder: "brewing_stepcomment",
          minLength: 3,
          maxLength: 300,
          showCount: true,
        };
      }
      const subHiddenStr = "brewing_step" + i + "_sub_hidden";
      const subHiddenFieldId: DataInputCommonParams = {
        fieldId: {},
        flexClassName: "brewing_sub brewing_hidden w-full hidden",
      };
      if (subHiddenFieldId.fieldId !== undefined && typeof subHiddenFieldId.fieldId !== "string") {
        subHiddenFieldId.fieldId[brewing_step_str + i + "_pourover_calc"] = {
          ...dc.brewingStepTimer,
          inputClassName: dc.brewingStepTimer.inputClassName + " brewing_drip",
        };
        subHiddenFieldId.fieldId[brewing_step_str + i + "_pourover_calc_end"] = {
          ...dc.brewingStepTimer,
          inputClassName: dc.brewingStepTimer.inputClassName + " brewing_drip",
        };
        subHiddenFieldId.fieldId[brewing_step_str + i + "_end_mass_disp"] = {
          ...dc.brewingMassCalc,
          saveData: false,
          readInputDisabled: false,
        };
        subHiddenFieldId.fieldId[brewing_step_str + i + "_calc_result"] = {
          ...dc.brewingMassCalc,
          saveData: false,
          readInputDisabled: false,
        };
      }

      tempFieldId[mainStr] = mainFieldId;
      tempFieldId[subEspStr] = subEspFieldId;
      // tempFieldId[subDripStr] = subDripFieldId;
      tempFieldId[subBrStr] = subBrFieldId;
      tempFieldId[subCommentStr] = subCommentFieldId;
      tempFieldId[subHiddenStr] = subHiddenFieldId;
    }
  }
  return result;
};

export const brewingChangeCalc = (form: FormInstance<any> | undefined, dataFunction: Record<string, Function> | undefined) => {
  if (form) {
    const fieldsValue = form.getFieldsValue([
      "brewing_step_use",
      "brewing_start_mass",
      "brewing_add_mass",
      "brewing_mass",
      "brewing_bean_mass",
      "brewing_result_tds",
      "brewing_type",
      "brewing_step1_result",
      "brewing_step2_result",
      "bean_mass_calc",
    ]);
    const start_mass = getNumber(fieldsValue.brewing_start_mass, 0);
    const add_mass = getNumber(fieldsValue.brewing_add_mass, 0);
    const result_mass = getNumber(fieldsValue.brewing_mass, 0);
    const bean_mass = getNumber(fieldsValue.brewing_bean_mass, 0);
    const result_tds = getNumber(fieldsValue.brewing_result_tds, 0);
    const brewing_type = fieldsValue.brewing_type;
    const bean_mass_calc = getNumber(fieldsValue.bean_mass_calc, 0);
    const bean_mass_ratio = bean_mass_calc === 0 ? 1 : bean_mass_calc / bean_mass;
    const bean_mass_real = bean_mass_ratio === 1 ? bean_mass : bean_mass_calc;
    Debug("bean_mass_ratio", bean_mass_ratio);
    //brewing_result_tds,brewing_result_weight,brewing_result_yield
    let total_mass = 0;
    const detail = fieldsValue.brewing_step_use;
    const setValues: Record<string, any> = { timeline_chart: true, brewing_step0_calc: start_mass, brewing_step0_end_mass_disp: 0 };
    if (detail) {
      let step2_change_0 = false;
      if (brewing_type === "ESP") {
        if (checkEmpty(fieldsValue.brewing_step1_result)) {
          step2_change_0 = true;
          setValues.brewing_step2_calc_result = 0;
        }
      } else if (brewing_type !== "ESP" && checkEmpty(fieldsValue.brewing_step1_result) && checkEmpty(fieldsValue.brewing_step2_result)) {
        step2_change_0 = true;
        setValues.brewing_step2_calc_result = 0;
      }
      let result_start = -1;
      let last_i = brewingCount;
      for (let i = brewingCount; i >= 1; i--) {
        const istr = brewingCount === i ? "_end" : i + "";
        if (!checkEmpty(form.getFieldValue(brewing_step_str + istr + "_term"))) {
          last_i = i;
          break;
        }
      }
      for (let i = 1; i <= brewingCount; i++) {
        const istr = brewingCount === i ? "_end" : i + "";
        const step_term = form.getFieldValue(brewing_step_str + istr + "_term");
        const step_mass_value = form.getFieldValue(brewing_step_str + istr + "_mass");
        const step_result_value = form.getFieldValue(brewing_step_str + istr + "_result");
        const step_mass = getNumber(step_mass_value, 0);
        const step_mass_calc = bean_mass_ratio * step_mass;
        const step_mass_calc_disp = step_mass_calc !== 0 ? Math.round(step_mass_calc * 10) / 10 : null;
        setValues[brewing_step_str + istr + "_mass_calc"] = null;

        if (step_mass_value === undefined || step_mass_value === null) {
          setValues[brewing_step_str + istr + "_calc"] = null;
        } else {
          total_mass += step_mass_calc;
          if (step_mass !== 0 && total_mass !== 0) {
            setValues[brewing_step_str + istr + "_mass_disp"] = step_mass_calc_disp;

            if (bean_mass_ratio !== 1) {
              setValues[brewing_step_str + istr + "_mass_calc"] = step_mass_calc_disp;
            }

            if (!(last_i === i && brewing_type === "ESP")) {
              setValues[brewing_step_str + istr + "_calc"] = Math.round((start_mass + total_mass) * 10) / 10;
            }
          } else {
            setValues[brewing_step_str + istr + "_calc"] = null;
          }
        }
        if (!checkEmpty(step_result_value)) {
          setValues[brewing_step_str + i + "_calc_result"] = step_result_value;
        } else {
          setValues[brewing_step_str + i + "_calc_result"] = step2_change_0 === true && i === 2 ? 0 : undefined;
        }
        if (brewing_type === "ESP") {
          if (result_start < 0 && step_term) {
            if (step_mass_value || step_result_value) {
              if (step_mass_value) {
                result_start = i;
              } else if (step_result_value) {
                //이전값의 result_value 를 0으로 만들어줌
                result_start = i - 1;
              }
            } else {
              setValues[brewing_step_str + (i - 1) + "_end_mass_disp"] = 0;
              setValues[brewing_step_str + i + "_calc_result"] = 0;
            }
          }
        }
        const step_pourover_value = form.getFieldValue(brewing_step_str + istr + "_pourover");

        const step_term_next = form.getFieldValue(
          last_i === i ? "brewing_term" : brewingCount === i + 1 ? brewing_step_str + "_end" : brewing_step_str + (i + 1) + "_term",
        );
        const step_term_calc =
          brewing_type === "ESP"
            ? step_term_next
            : !step_pourover_value && step_term
              ? dayjs(step_term + Math.round((step_mass_calc / 7) * 10) * 100)
              : undefined;
        const step_pourover_calc =
          step_pourover_value ??
          (step_term_calc && step_term_next
            ? step_term_calc < step_term_next
              ? step_term_calc
              : brewing_type === "ESP"
                ? step_term_next
                : undefined
            : (step_term_calc ?? step_term_next));

        setValues[brewing_step_str + istr + "_pourover_calc"] = step_pourover_calc;
        const step_pourover_calc_end =
          step_pourover_calc && step_term_next
            ? brewing_type !== "ESP" && dayjs(step_pourover_calc + 1000) < step_term_next
              ? dayjs(step_pourover_calc + 1000)
              : step_term_next
            : step_term_next;
        if (brewing_type === "ESP") {
          if (!checkEmpty(form.getFieldValue(brewing_step_str + istr + "_bar"))) {
            setValues.brewing_term_bar = form.getFieldValue(brewing_step_str + istr + "_bar");
          }
          if (!checkEmpty(form.getFieldValue(brewing_step_str + istr + "_flux"))) {
            setValues.brewing_term_flux = form.getFieldValue(brewing_step_str + istr + "_flux");
          }
        }
        if (step_pourover_calc_end) {
          if (!(last_i === i && brewing_type === "ESP")) {
            setValues[brewing_step_str + istr + "_pourover_calc_end"] = step_pourover_calc_end;
          }
          if (brewing_type !== "ESP") {
            setValues[brewing_step_str + istr + "_end_mass_disp"] = 0;
          }
        } else {
          setValues[brewing_step_str + istr + "_pourover_calc_end"] = null;
          setValues[brewing_step_str + istr + "_end_mass_disp"] = null;
        }
      }
    } else {
      total_mass = result_mass;
    }
    const result_mass_calc = result_mass * bean_mass_ratio;
    const add_mass_calc = add_mass * bean_mass_ratio;
    const result_total = result_mass_calc + add_mass_calc;
    const water_mass = total_mass + add_mass_calc;
    setValues.brewing_term_calc = total_mass + start_mass;
    setValues.brewing_result_total = result_total !== 0 ? result_total : null;
    setValues.brewing_result_calc = water_mass !== 0 ? water_mass : null;
    setValues.brewing_result_ratio =
      bean_mass !== 0 && result_mass !== 0
        ? "1:" +
          Math.floor((result_mass_calc / bean_mass_real) * 10) / 10 +
          (add_mass !== 0 ? " / 1:" + Math.floor((result_total / bean_mass_real) * 10) / 10 : "")
        : null;
    setValues.brewing_water_ratio =
      bean_mass !== 0 && water_mass !== 0 && result_mass !== water_mass ? "1:" + Math.floor((water_mass / bean_mass_real) * 10) / 10 : null;
    setValues.brewing_result_weight = result_tds !== 0 && result_mass !== 0 ? (result_tds * result_mass_calc) / 100 : null;
    setValues.brewing_result_yield =
      setValues.brewing_result_weight !== null && bean_mass !== 0
        ? Math.floor((setValues.brewing_result_weight / bean_mass_real) * 10000) / 100
        : null;
    setValues.brewing_add_mass_calc = bean_mass_ratio === 1 ? null : add_mass_calc;
    Debug("brewingChangeCalc : ", fieldsValue, setValues);
    setFormClass(dataFunction, { bean_mass_ratio: bean_mass_ratio !== 1 });
    form.setFieldsValue(setValues);
  }
};

export const brewingInit = (
  form: FormInstance<any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  dataFunction: Record<string, Function> | undefined,
  data: any,
  setTimer: Function | undefined,
) => {
  //
  const checkData = data ?? {};
  const now_check = document.querySelectorAll("form.ant-form .rt-DataListItem .now-check");
  now_check.forEach((item) => item.classList.remove("now-check"));
  brewingTimers.forEach((item) => {
    runFormFunction(formFunction, item, "setNow", undefined);
  });
  if (setTimer) {
    setTimer({ timer: dc.brewingTimer, start: undefined });
  }
  setTimeout(() => {
    setFormClass(dataFunction, {
      brewing_detail_use: checkData["brewing_detail_use"] ?? false,
      brewing_espresso_use: checkData["brewing_type"] === "ESP",
      brewing_drip_use: checkData["brewing_type"] === "DRP",
      hidden_step_detail: !((checkData["brewing_step_use"] ?? 0) === 1),
    });
    brewingChangeCalc(form, dataFunction);
  }, dc.setTimeoutDelay);
};

export const brewingSteps = (
  t: TransitionType,
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formMemo: Record<string, any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  dataFunction: Record<string, Function> | undefined,
  setTimer: Function | undefined,
  brewing_start_time: boolean,
  beaninfo: boolean,
): DataColumnRecord => {
  const beaninfos = beaninfo
    ? { noItem: false, disabled: false, readInput: true, readInputDisabled: true, read: { show: true, display: true } }
    : {};
  return {
    brewing_info: {
      labelClassName: dc.strongLabelClassName,
      itemClassName: "brewing_result",
      // read: beaninfo ? checkChange : { display: "notNull", displayCheckIds: ["brewing_mass", "brewing_temp", "brewing_bar"] },
      fieldId: {
        brewing_mass: {
          ...dc.mass,
          variant: "outlined",
          tooltip: "result_mass",
          placeholder: "result_mass",
          noItem: false,
          readInput: true,
          readInputDisabled: true,
          onChange: (e) => {
            brewingChangeCalc(form?.current, dataFunction);
          },
          ...beaninfos,
        },
        brewing_temp: { ...dc.temp, variant: "outlined", tooltip: "brewing_temp", placeholder: "brewing_temp", ...beaninfos },
        brewing_bar: { ...dc.brewingBar, variant: "outlined", tooltip: "brewing_bar", read: { display: "notNull" }, ...beaninfos },
      },
    },
    timeline_chart: {
      itemClassName: "brewing_result step_detail",
      ...dc.timelineChart,
      transitionGroup: "brewingChart",
      // timelineProp: getTimelineProp(25),
      indexKey: "brewing_start_time",
      imageDownload: "BrewingTimer",
      timelineProp: {
        fixed: true,
        showTimes: { ...getBrewingChartShowTime() },
        checkIds: ["mass_disp", "calc", "result", "flux", "bar"],
        checkTimes: [
          brewing_step_str + "1_pourover_calc",
          ...getIntArray(brewingCount, 2).flatMap((i) => {
            return [brewing_step_str + i + "_term", brewing_step_str + i + "_pourover_calc"];
          }),
          "brewing_term",
        ],
        // calcValues: /_end_mass$|_calc$|_pourover_calc$|_pourover_calc_end$|^_calc$/g,
        calcValues: [
          ...getIntArray(brewingCount, 0).flatMap((i) => {
            return [
              "term",
              "end_mass_disp",
              "calc",
              "calc_result",
              "pourover",
              "pourover_calc",
              "pourover_calc_end",
              "mass_disp",
              "result",
              "end",
              "bar",
              "flux",
            ].map((t) => brewing_step_str + i + "_" + t);
          }),
          ...["step0_mass_disp", "step0_end_mass_disp", "step0_calc", "term_bar", "term_flux", "term_calc", "term", "mass"].map(
            (a) => "brewing_" + a,
          ),
        ],
        colorMap: {
          result: { color: "#cea37e" },
          mass_disp: { color: "#0084e6a1" },
          calc: { color: "#dc9b009d" },
          bar: { color: "#e4cdb7" },
          flux: { color: "#e4cdb7" },
        },
        fill: dc.timelineFill({ full: ["result", "mass_disp"], fill: ["calc", "bar"] }),
        timerStart: () => {
          brewingTimerStart(form?.current, formMemo, formFunction, { value: dayjs() }, true, setTimer);
        },
        timerStop: () => {
          if (form?.current?.getFieldValue("brewing_term")) {
            runFormFunction(formFunction, "timeline_chart", "setStartTime", undefined);
            brewingTimerClear(formMemo);
          } else {
            runFormFunction(formFunction, "brewing_term", "setNowClick");
          }

          // brewing_term
        },
        timerClock: {
          onClick: () => {
            const clock_list = [
              ...getIntArray(brewingCount - 1, 1).flatMap((i) => {
                return brewing_step_str + i;
              }),
              brewing_step_str + "_end",
            ];
            const term_list = clock_list.map((item) => item + "_term");

            const checkValues = form?.current?.getFieldsValue([
              "brewing_type",
              "brewing_step_use",
              ...term_list,
              // "brewing_detail_use",
              // ...clock_list.map((item) => item + "_pourover"),
            ]);
            Debug(checkValues);
            if (checkValues.brewing_step_use) {
              // const brewing_type = checkValues["brewing_type"];
              // const brewing_detail_use = checkValues["brewing_detail_use"];
              // const checkList =
              //   brewing_detail_use && brewing_type === "DRP"
              //     ? clock_list.flatMap((item) => [item + "_term", item + "_pourover"])
              //     : term_list;

              const check = clock_list.find((item) => checkEmpty(checkValues[item + "_term"]));
              if (check) {
                runFormFunction(formFunction, check + "_term", "setNowClick");
                focusFormField(form?.current, check + "_mass");
              }
            }
          },
        },
        xMinText: t("brewing_start"),
        xFloorScale: 10000,
        xFloorConst: 0,
        xBottomTickZeroShow: false,
        xTopShowTime: true,
        xBottomTickValues: "every 1 minute",
        yFloorScale: 25,
        yViewScale: 10,
        yUnit: "g",
        ySeriesUnit: { bar: "bar", flux: "g/s" },
        ySeriesScale: ["bar"],
        yGridCount: 6,
        min: { x: new Date(0), y: 0 },
        max: { x: new Date(30000), y: 20 },
        // beforeId: "roasting_before",
        pointLabelLimit: { min: 0.1 },
        pointLabelIdLimit: { mass: { min: 0.1 } },
        logId: "brewing_chart_log",
      },
    },
    brewing_before: { ...dc.textArea, maxLength: 3000, itemClassName: "brewing_result brewing_detail", ...beaninfos },
    brewing_info_text: {
      ...dc.guideDefault,
      itemClassName: "brewing_result " + dc.guideDefault.itemClassName,
      fixedValue: "brewing_info_text",
      read: { fixedValue: "brewing_info_text_read" },
    },
    // brewing_info_text_sub: {
    //   label: "blank",
    //   inputType: "display",
    //   itemClassName: "font-bold",
    //   fixedValue: "brewing_info_text_sub",
    //   read: { display: false },
    //   transition: true,
    // },
    brewing_start: {
      // labelClassName: dc.strongLabelClassName,
      itemClassName: "brewing_result",
      fieldId: {
        brewing_start_time: {
          ...dc.datetime,
          inputClassName: dc.roastingTimeWidth,
          noItem: false,
          readInputDisabled: false,
          // read: { dateFormatter: "A hh:mm:ss" },
          dateFormatter: "A hh:mm:ss",
          dateProp: { nowButton: true, suffixIcon: "" },
          disabled: !brewing_start_time,
          tooltip: true,
          tooltipPlacement: "leftTop",
          variant: "outlined",
          indexKey: "brewing_start_time",
          onChange: (e: any) => {
            brewingTimerStart(form?.current, formMemo, formFunction, e, false, setTimer);
          },
          // saveData: false,
        },
        brewing_start_mass: {
          ...dc.mass,
          readInputDisabled: false,
          noItem: false,
          readOnly: false,
          variant: "outlined",
          tooltip: "start_weight",
          placeholder: "start_weight",
          placeholderForce: true,
          onChange: () => brewingChangeCalc(form?.current, dataFunction),
        },
        bean_mass_calc: {
          ...dc.mass,
          edit: { display: false },
          readInputDisabled: false,
          noItem: false,
          readOnly: false,
          variant: "outlined",
          tooltip: "bean_mass_calc",
          placeholder: "bean_mass_calc",
          placeholderForce: true,
          onChange: () => brewingChangeCalc(form?.current, dataFunction),
        },
        brewing_step_use: {
          ...dc.use,
          inputClassName: dc.inputNumberWithButtonWidth + " my-auto",
          noItem: false,
          readOnly: false,
          readInputDisabled: beaninfo ? true : false,
          read: {
            display: "true",
            inputClassName: dc.inputCalcWidth + " my-auto",
            switchProp: { checkedChildren: t("detail_show"), unCheckedChildren: t("detail_hidden") },
          },
          create: { defaultValue: false },
          edit: { switchProp: { checkedChildren: t("detail_enable"), unCheckedChildren: t("detail_disable") } },
          changePass: true,
          onChange: beaninfo
            ? undefined
            : (e: any) => {
                setFormClass(dataFunction, { hidden_step_detail: !e.value });
                setTimeout(() => {
                  brewingChangeCalc(form?.current, dataFunction);
                }, dc.setTimeoutShort);
              },
        },
        brewing_step_sort: {
          read: { display: false },
          ...dc.buttonDefault(
            "SortAscending",
            () => {
              const checkForm = form?.current;
              if (checkForm) {
                const getFields: string[] = [];
                const fieldArr = ["_term", "_mass", "_bar", "_flux", "_result", "_pourover", "_comment"];
                const nowArr: Record<string, any> = {};

                for (let i = 1; i <= brewingCount; i++) {
                  fieldArr.forEach((field) => getFields.push(brewing_step_str + i + field));
                  nowArr[i + ""] =
                    formMemo && formMemo[brewing_step_str + i + "_term"] ? formMemo[brewing_step_str + i + "_term"].now : undefined;
                }
                const getValues = getFields.length > 0 ? checkForm.getFieldsValue(getFields) : {};

                const termArr: { term: dayjs.Dayjs; index: number }[] = [];
                for (let i = 1; i <= brewingCount; i++) {
                  const setNow =
                    formMemo && formMemo[brewing_step_str + i + "_term"] ? formMemo[brewing_step_str + i + "_term"].now : undefined;
                  termArr.push({ term: getValues[brewing_step_str + i + "_term"], index: i });
                }
                const setValues: Record<string, any> = {};

                termArr.sort((a, b) => (a.term && b.term ? a.term.valueOf() - b.term.valueOf() : a.term ? -1 : b.term ? 1 : 0));
                termArr.forEach((value, index) => {
                  fieldArr.forEach((field) => {
                    setValues[brewing_step_str + (index + 1) + field] = getValues[brewing_step_str + value.index + field];
                  });
                  runFormFunction(formFunction, brewing_step_str + (index + 1) + "_term", "setNow", nowArr[value.index + ""]);
                });
                Debug(setValues);
                checkForm.setFieldsValue(setValues);
                brewingChangeCalc(form?.current, dataFunction);
              }
            },
            "default",
            undefined,
            "ml-2 px-2 step_detail",
          ),
          tooltip: "sort_asc_label",
        },
      },
    },
    brewing_step_explain: {
      label: "blank",
      labelClassName: dc.mobileHidden,
      valueClassName: "MobileUnderLine",
      itemClassName: "brewing_result step_detail",
      fieldId: {
        brewing_step_explia_main: {
          flexClassName: "brewing_main",
          fieldId: {
            brewing_step_explain_term: {
              ...dc.timer,
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              inputClassName: dc.roastingTimeWidth,
              timeProp: { ...dc.timer.timeProp, nowButton: true, nowButtonClassName: "invisible" },
              // read: { timeProp: { ...dc.timer.timeProp, nowButton: true } },
              placeholder: "brewing_step_time",
              noItem: true,
            },
            brewing_step_explain_calc: {
              ...dc.brewingMassCalc,
              placeholder: "calc_mass",
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
            },
            brewing_step_explain_mass_calc: {
              ...dc.brewingMass,
              inputClassName: dc.brewingMass.inputClassName + " brewing_mass_calc",
              edit: { display: false },
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
            },
            brewing_step_explain_mass: {
              ...dc.brewingMass,
              inputClassName: dc.brewingMass.inputClassName + " brewing_mass",
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
            },
          },
        },
        brewing_step_explain_sub_esp: {
          flexClassName: "brewing_sub ml-2 brewing_detail hidden lg:flex",
          fieldId: {
            brewing_step_explain_pourover: {
              ...dc.timer,
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              inputClassName: dc.roastingTimeWidth + " brewing_drip",
              timeProp: { ...dc.timer.timeProp, nowButton: true, nowButtonClassName: "invisible" },
              // read: { timeProp: { ...dc.timer.timeProp, nowButton: true } },
              placeholder: "brewing_pourover",
              noItem: true,
              read: beaninfo
                ? undefined
                : {
                    display: "notNull",
                    displayCheckIds: getBrewingStepArr("_pourover"),
                  },
            },
            brewing_step_explain_result: {
              ...dc.brewingMass,
              inputClassName: dc.inputNumberClassName + " brewing_step_result",
              placeholder: "brewing_mass",
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
              read: beaninfo
                ? undefined
                : {
                    display: "notNull",
                    displayCheckIds: getBrewingStepArr("_result"),
                  },
            },

            brewing_step_explain_bar: {
              ...dc.brewingBar,
              inputClassName: dc.brewingBar.inputClassName + " brewing_espresso",
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
              read: beaninfo
                ? undefined
                : {
                    display: "notNull",
                    displayCheckIds: getBrewingStepArr("_bar"),
                  },
            },
            brewing_step_explain_flux: {
              ...dc.brewingFlux,
              inputClassName: dc.brewingFlux.inputClassName + " brewing_espresso",
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
              read: beaninfo
                ? undefined
                : {
                    display: "notNull",
                    displayCheckIds: getBrewingStepArr("_flux"),
                  },
            },
          },
        },
      },
    },
    ...getBrewingStep(brewingCount, beaninfo, () => brewingChangeCalc(form?.current, dataFunction)),
    brewing_step_end: {
      itemClassName: "brewing_result step_detail",
      labelClassName: dc.mobileHidden,
      read: { display: "notNull", displayCheckIds: ["brewing_step_end_term", "brewing_step_end_mass_disp"] },
      fieldId: {
        brewing_step_end_term: {
          ...dc.timer,
          inputClassName: dc.roastingTimeWidth,
          indexKey: "brewing_start_time",
          noItem: false,
          onChange: () => brewingChangeCalc(form?.current, dataFunction),
          //read: { timeProp: { ...dc.timer.timeProp, nowButton: false } },
        },
        brewing_step_end_calc: dc.brewingMassCalc,
        brewing_step_end_mass_disp: {
          ...dc.brewingMass,
          hiddenCheckValue: undefined,
          onChange: () => brewingChangeCalc(form?.current, dataFunction),
        },
      },
    },
    brewing_step_end_split: {
      label: "blank",
      itemClassName: "brewing_result !hidden",
    },
    brewing_result: {
      labelClassName: dc.strongLabelClassName,
      itemClassName: "brewing_result",
      fieldId: {
        brewing_term: {
          ...dc.timer,
          inputClassName: dc.roastingTimeWidth,
          indexKey: "brewing_start_time",
          noItem: false,
          variant: "outlined",
          //readInputDisabled: false,
          onChange: (e: any) => {
            brewingChangeCalc(form?.current, dataFunction);
            if (setTimer) {
              if (e && e.value) {
                setTimer({ timer: dc.brewingTimer, start: undefined });
                brewingTimerClear(formMemo);
              }
            }
          },
        },
        brewing_result_total: { ...dc.brewingMassCalc, tooltip: "brewing_result_total", saveData: false },
        brewing_add_mass_calc: {
          ...dc.brewingMass,
          inputClassName: dc.brewingMass.inputClassName + " brewing_mass_calc",
          unitPrev: "+",
          tooltip: "brewing_add_mass",
          placeholder: "brewing_add_mass",
          edit: { display: false },
          ...beaninfos,
        },
        brewing_add_mass: {
          ...dc.brewingMass,
          inputClassName: dc.brewingMass.inputClassName + " brewing_mass",
          unitPrev: "+",
          // unitPrev: { element: "brewing_add_mass", transition: true },
          tooltip: "brewing_add_mass",
          placeholder: "brewing_add_mass",
          onChange: () => brewingChangeCalc(form?.current, dataFunction),
          read: { display: "notNull" },
          ...beaninfos,
        },
        brewing_step0_end_mass_disp: {
          ...dc.brewingMassCalc,
          saveData: false,
          readInput: true,
          readInputDisabled: false,
          inputClassName: "hidden",
        },
        brewing_step0_calc: { ...dc.brewingMassCalc, saveData: false, readInput: true, readInputDisabled: true, inputClassName: "hidden" },
        brewing_term_calc: { ...dc.brewingMassCalc, saveData: false, readInput: true, readInputDisabled: true, inputClassName: "hidden" },
        brewing_term_bar: {
          ...dc.brewingBar,
          saveData: false,
          noItem: false,
          readInput: true,
          readInputDisabled: true,
          inputClassName: "hidden",
        },
        brewing_term_flux: {
          ...dc.brewingFlux,
          saveData: false,
          noItem: false,
          readInput: true,
          readInputDisabled: true,
          inputClassName: "hidden",
        },
      },
    },
    brewing_result_tds_div: {
      label: "brewing_result_tds",
      itemClassName: "brewing_result",
      display: brewing_start_time,
      read: { display: "notNull", displayCheckIds: ["brewing_result_tds"] },
      fieldId: {
        brewing_result_tds: {
          ...dc.percent,
          formatter: defaultFloatFomatter,
          scale: 100,
          step: 0.01,
          placeholder: "brewing_result_tds",
          tooltip: "brewing_result_tds",
          inputClassName: dc.roastingTimeWidth + " text-last brewing_result mr-[2.5rem]",
          onChange: () => brewingChangeCalc(form?.current, dataFunction),
          // read: { display: "notNull", displayCheckIds: undefined },
          ...beaninfos,
        },
        brewing_result_weight: {
          ...dc.mass,
          noItem: false,
          disabled: true,
          readOnly: true,
          variant: "outlined",
          inputClassName: dc.inputCalcClassName + " text-last brewing_result",
          placeholder: "",
          tooltip: "brewing_result_weight",
          saveData: false,
          // read: { display: "notNull", displayCheckIds: undefined },
        },
        brewing_result_yield: {
          ...dc.percent,
          formatter: defaultFloatFomatter,
          noItem: false,
          disabled: true,
          readOnly: true,
          variant: "outlined",
          inputClassName: dc.inputCalcClassName + " text-last brewing_result",
          tooltip: "brewing_result_yield",
          saveData: false,
          // read: { display: "notNull", displayCheckIds: undefined },
        },
      },
    },
    brewing_result_explain: {
      label: "brewing_result_ratio",
      labelClassName: dc.mobileHidden,
      itemClassName: "brewing_result",
      fieldId: {
        // brewing_result_explain_blank: {
        //   ...dc.timer,
        //   disabled: true,
        //   readOnly: true,
        //   variant: "borderless",
        //   unit: "",
        //   inputClassName: dc.roastingTimeWidth,
        //   timeProp: { ...dc.timer.timeProp, nowButton: true, nowButtonClassName: "invisible" },
        //   // read: { timeProp: { ...dc.timer.timeProp, nowButton: true } },
        //   placeholder: "blank",
        //   noItem: true,
        // },
        brewing_result_ratio: {
          ...dc.inputDisabled,
          widthFull: false,
          noItem: false,
          disabled: true,
          readOnly: true,
          tooltip: "brewing_result_ratio",
          inputClassName: dc.roastingTimeWidth + " text-end input_bold mr-[2.5rem]",
          allowClear: false,
          read: { variant: "borderless" },
          saveData: false,
        },
        brewing_water_ratio: {
          ...dc.inputDisabled,
          widthFull: false,
          noItem: false,
          disabled: true,
          readOnly: true,
          tooltip: "brewing_water_ratio",
          inputClassName: dc.inputNumberClassName + " text-end input_bold",
          allowClear: false,
          read: { variant: "borderless" },
          saveData: false,
        },
        brewing_result_calc: {
          ...dc.brewingMassCalc,
          // placeholder: "brewing_add_total",
          tooltip: "brewing_add_total",
          inputClassName: dc.inputNumberClassName + " step_detail",
          read: { variant: "borderless" },
          saveData: false,
        },
      },
    },
    brewing_after: { ...dc.textArea, maxLength: 3000, itemClassName: "brewing_result brewing_detail", ...beaninfos },
  };
};

export const brewingCommon = (
  t: TransitionType,
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formMemo: Record<string, any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  dataFunction: Record<string, Function> | undefined,
  locale: string | undefined,
  authDataType: AuthDataType | "info",
  brewing_start_time: boolean,
  setTimer: Function | undefined,
  mode: "default" | "result" | "demo" | "beaninfo",
): DataColumnRecord => {
  const beaninfo = mode === "beaninfo";
  const beaninfos = beaninfo
    ? { noItem: false, disabled: false, readInput: true, readInputDisabled: true, read: { show: true, display: true } }
    : {};
  return {
    brewing_grinder_detail: {
      label: "grinder_zeropoint",
      labelClassName: dc.mobileHidden,
      itemClassName: "brewing_result",
      // itemClassName: "brewing_detail",
      read: beaninfo
        ? undefined
        : { display: "notNull", displayCheckIds: ["brewing_grinder_zeropoint", "brewing_grinder_temp", "brewing_grinder_rpm"] },
      fieldId: {
        brewing_grinder_zeropoint: {
          ...dc.number1f,
          scale: 100,
          variant: "outlined",
          formatter: defaultFloatFomatter,
          inputClassName: dc.inputNumberClassName + " number-last", // + " brewing_detail",
          placeholder: "grinder_zeropoint",
          tooltip: "grinder_zeropoint",
          tooltipPlacement: "top",
          read: { display: "notNull", displayCheckIds: undefined },
          ...beaninfos,
        },
        brewing_grinder_temp: {
          ...dc.temp,
          inputClassName: dc.temp.inputClassName + " brewing_detail",
          variant: "outlined",
          placeholder: "grinder",
          tooltip: "grinder_temp",
          tooltipPlacement: "top",
          read: { display: "notNull", displayCheckIds: undefined },
          ...beaninfos,
        },
        brewing_grinder_rpm: {
          ...dc.number,
          inputClassName: dc.inputNumberClassName + " brewing_detail",
          unit: "RPM",
          variant: "outlined",
          placeholder: "grinder",
          tooltip: "grinder_rpm",
          tooltipPlacement: "top",
          read: { display: "notNull", displayCheckIds: undefined },
          ...beaninfos,
        },
      },
    },
    brewing_grinder_setting: {
      labelClassName: dc.strongLabelClassName,
      itemClassName: "brewing_result",
      fieldId: {
        brewing_bean_mass: { ...dc.mass, variant: "outlined", tooltip: "bean_mass", placeholder: "bean_mass", noItem: false },
        brewing_grinder_point: {
          ...dc.number2f,
          variant: "outlined",
          tooltip: "grinder_point",
          placeholder: "grinder_point",
          formatter: defaultFloatFomatter,
          inputClassName: dc.inputNumberClassName + " number-last",
          onChange: () => brewingChangeCalc(form?.current, dataFunction),
          ...beaninfos,
        },
        brewing_grinder_term: {
          ...dc.number2f,
          variant: "outlined",
          tooltip: "grinder_term",
          placeholder: "grinder_term",
          unit: "s",
          formatter: defaultFloatFomatter,
          inputClassName: dc.inputNumberClassName + " number-last",
          read: { display: "notNull" },
          ...beaninfos,
        },
      },
    },
    brewing_detail_2: {
      label: "espresso_part",
      labelClassName: dc.mobileHidden,
      itemClassName: "brewing_result brewing_detail brewing_espresso",
      display: mode !== "demo",
      read: beaninfo ? checkChange : { display: "notNull", displayCheckIds: ["brewing_shower", "brewing_basket", "brewing_temper"] },
      fieldId: {
        brewing_shower: {
          ...dc.equipSelect(authDataType, locale),
          inputClassName: dc.inputNumberWidth,
          variant: "outlined",
          selectPropOption: { reloadButton: false },
          placeholder: "shower",
          selectFilter: { equip_type: "SHR" },
          ...beaninfos,
        },
        brewing_basket: {
          ...dc.equipSelect(authDataType, locale),
          inputClassName: dc.inputNumberWidth,
          variant: "outlined",
          selectPropOption: { reloadButton: false },
          placeholder: "basket",
          selectFilter: { equip_type: "BSKT" },
          ...beaninfos,
        },
        brewing_temper: {
          ...dc.equipSelect(authDataType, locale),
          inputClassName: dc.inputNumberWidth,
          variant: "outlined",
          selectPropOption: { reloadButton: false },
          placeholder: "temper",
          selectFilter: { equip_type: "TMP" },
          ...beaninfos,
        },
      },
    },
    brewing_detail_3: {
      label: "dosing",
      labelClassName: dc.mobileHidden,
      itemClassName: "brewing_result brewing_detail brewing_espresso",
      read: beaninfo ? checkChange : { display: "notNull", displayCheckIds: ["brewing_wdt", "brewing_dist", "brewing_temping_bar"] },
      fieldId: {
        brewing_wdt: { ...dc.count, placeholder: "wdt", tooltip: "wdt_tooltip", ...beaninfos },
        brewing_dist: { ...dc.mm, placeholder: "distributor", ...beaninfos },
        brewing_temping_bar: { ...dc.bar, placeholder: "temping_bar", ...beaninfos },
        //brewing_temping_count: { ...dc.count, placeholder: "temping_count" },
      },
    },

    ...brewingSteps(t, form, formMemo, formFunction, dataFunction, setTimer, brewing_start_time, beaninfo),
    //brewing_bean: { labelClassName: dc.strongLabelClassName, fieldId: {} },
  };
};

export const brewingType = (
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formMemo: Record<string, any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  dataFunction: Record<string, Function> | undefined,
  locale: string | undefined,
  authDataType: AuthDataType | "info",
  mode: "default" | "result" | "demo" | "beaninfo",
): DataColumnRecord => {
  const demo = mode === "demo";
  const beaninfo = mode === "beaninfo";
  const beaninfos = beaninfo
    ? { noItem: false, disabled: false, readInput: true, readInputDisabled: true, read: { show: true, display: true } }
    : {};
  return {
    brewing_machine_etc: {
      ...dc.inputFull,
      itemClassName: "brewing_result brewing_machine_etc_item",
      minLength: 3,
      maxLength: 100,
      showCount: true,
      label: demo ? "brewing_machine_name" : "blank",
      labelClassName: demo ? undefined : dc.mobileHidden,
      placeholder: "brewing_machine_name",
      ...beaninfos,
    },
    brewing_machine_name: {
      label: demo ? "brewing_type" : "brewing_machine_name",
      itemClassName: "brewing_result",
      fieldId: {
        brewing_machine_seq: {
          ...dc.equipSelect(authDataType, locale),
          inputClassName: dc.inputCountryClassName,
          selectFilter: { equip_type: ["ESP", "DRP"] },
          tooltip: "brewing_machine_name",
          placeholder: "brewing_machine_name",
          inputDirect: { target: "brewing_machine_etc", query: ".brewing_machine_etc_item" },
          read: { show: "notNull" },
          display: !demo,
          selectPropOption: { reloadButton: false },
          ...beaninfos,
        },
        brewing_type: {
          ...dc.select,
          codeGroup: "EXTR",
          // defaultValue: "DRP",
          tooltip: "brewing_type",
          placeholder: "brewing_type",
          // inputDirect: true,
          inputDirect: { target: "brewing_type_etc", query: ".brewing_type_etc_item" },
          selectPropOption: { reloadButton: false },
          onChange: (e) => {
            setFormClass(dataFunction, { brewing_espresso_use: e.value === "ESP", brewing_drip_use: e.value === "DRP" });
          },
          read: { show: "notNull" },
          noItem: false,
          ...beaninfos,
        },
      },
    },
    brewing_type_etc: {
      ...dc.inputFull,
      itemClassName: "brewing_result brewing_type_etc_item",
      minLength: 3,
      maxLength: 100,
      showCount: true,
      label: "blank",
      labelClassName: dc.mobileHidden,
      placeholder: "brewing_type",
      ...beaninfos,
    },
    brewing_dripfilter_seq: {
      ...dc.equipSelect(authDataType, locale),
      label: "brewing_dripfilter_name",
      itemClassName: "brewing_result brewing_drip",
      inputClassName: dc.inputCountryClassName,
      selectFilter: { equip_type: "DRFT" },
      tooltip: "brewing_dripfilter_name",
      placeholder: "brewing_dripfilter_name",
      // dataProp: {},
      inputDirect: { target: "brewing_dripfilter_etc", query: ".brewing_dripfilter_etc_item" },
      read: { show: "notNull" },
      display: !demo,
      ...beaninfos,
    },
    brewing_dripfilter_etc: {
      ...dc.inputFull,
      itemClassName: "brewing_result brewing_drip brewing_dripfilter_etc_item",
      minLength: 3,
      maxLength: 100,
      showCount: true,
      label: demo ? "brewing_dripfilter_name" : "blank",
      labelClassName: demo ? undefined : dc.mobileHidden,
      placeholder: "brewing_dripfilter_name",
      read: { display: "notNull" },
      ...beaninfos,
    },
    brewing_grinder_seq: {
      ...dc.equipSelect(authDataType, locale),
      itemClassName: "brewing_result",
      inputClassName: dc.inputCountryClassName,
      selectFilter: { equip_type: "GRND" },
      tooltip: "brewing_grinder_name",
      placeholder: "brewing_grinder_name",
      selectWithLoad: ["brewing_machine_seq", "brewing_dripfilter_seq", "brewing_shower", "brewing_basket", "brewing_temper"],
      // dataProp: {},
      create: { dataProp: { firstReload: mode === "default" } },
      onChange: (data) => {
        const temp_result = runFormFunction(formFunction, "brewing_grinder_seq", "selectData");
        // Debug(temp_result.result);
        form?.current?.setFieldsValue(
          convertFormValues(formMemo, {
            brewing_grinder_zeropoint: temp_result.result ? temp_result.result["equip_zero_point"] : undefined,
          }),
        );
      },
      inputDirect: { target: "brewing_grinder_etc", query: ".brewing_grinder_etc_item" },
      read: { show: "notNull", onChange: undefined },
      display: !demo,
      ...beaninfos,
    },
    brewing_grinder_etc: {
      ...dc.inputFull,
      itemClassName: "brewing_result brewing_grinder_etc_item",
      minLength: 3,
      maxLength: 100,
      showCount: true,
      label: demo ? "brewing_grinder_seq" : "blank",
      labelClassName: demo ? undefined : dc.mobileHidden,
      placeholder: "brewing_grinder_name",
      ...beaninfos,
    },
    brewing_detail: {
      label: "brewing_detail_use",
      valueClassName: "min-h-9",
      itemClassName: "brewing_result",
      read: beaninfo
        ? undefined
        : { display: "true", displayCheckIds: ["brewing_detail_use"], itemClassName: "brewing_result brewing_detail" },
      fieldId: {
        brewing_detail_use: {
          ...dc.useDefault,
          create: { defaultValue: false },
          inputClassName: "my-auto mr-[3.25rem] md:mr-[4.25rem]",
          read: {
            // display: false,
            // inputClassName: "my-auto mr-[3.25rem] md:mr-[4.25rem]"
          },
          onChange: (e: any) => {
            setFormClass(dataFunction, { brewing_detail_use: e.value });
          },
          ...beaninfos,
        },
        brewing_rdt: {
          ...dc.count,
          variant: "outlined",
          read: { display: "notNull", displayCheckIds: undefined },
          inputClassName: dc.inputNumberClassName + " h-[2rem] brewing_detail",
          placeholder: "rdt",
          tooltip: "rdt_count",
          ...beaninfos,
        },
        brewing_water: {
          ...dc.select,
          inputClassName: dc.inputNumberClassName + " brewing_detail",
          variant: "outlined",
          placeholder: "brewing_water",
          tooltip: true,
          codeGroup: "WTR",
          read: { display: "notNull", displayCheckIds: undefined },
          inputDirect: { target: "brewing_water_etc", query: ".brewing_water_etc_item" },
          selectPropOption: { reloadButton: false },
          ...beaninfos,
        },
      },
    },
    brewing_water_etc: {
      ...dc.inputFull,
      itemClassName: "brewing_result brewing_detail brewing_water_etc_item",
      minLength: 3,
      maxLength: 100,
      showCount: true,
      label: "blank",
      labelClassName: dc.mobileHidden,
      read: { display: "notNull", displayCheckIds: ["brewing_water"] },
      placeholder: "brewing_water",
      ...beaninfos,
    },
    brewing_detail_1: {
      label: "brewing_water",
      labelClassName: dc.mobileHidden,
      itemClassName: "brewing_result brewing_detail",
      read: beaninfo
        ? undefined
        : { display: "notNull", displayCheckIds: ["brewing_water_hard", "brewing_water_alk", "brewing_water_tds"] },
      fieldId: {
        brewing_water_hard: {
          ...dc.waterHard,
          read: { display: "notNull" },
          variant: "outlined",
          tooltip: "brewing_water_hard",
          ...beaninfos,
        },
        brewing_water_alk: {
          ...dc.waterAlk,
          read: { display: "notNull" },
          variant: "outlined",
          tooltip: "brewing_water_alk",
          ...beaninfos,
        },
        brewing_water_tds: {
          ...dc.waterTds,
          read: { display: "notNull" },
          variant: "outlined",
          tooltip: "brewing_water_tds",
          ...beaninfos,
        },
      },
    },
  };
};

export const coffeebeanBestDate: DataColumnRecord = {
  brewing_best_date: {
    read: { display: "notNull", displayCheckIds: ["brewing_best_start", "brewing_best_end"] },
    fieldId: {
      brewing_best_start: { ...dc.dayNumber, tooltip: "best_start" },
      brewing_best_end: { ...dc.dayNumber, tooltip: "best_end" },
    },
  },
  espresso_best_date: {
    read: { display: "notNull", displayCheckIds: ["espresso_best_start", "espresso_best_end"] },
    fieldId: {
      espresso_best_start: { ...dc.dayNumber, tooltip: "best_start" },
      espresso_best_end: { ...dc.dayNumber, tooltip: "best_end" },
    },
  },
};

export const brewingDefault = (
  t: TransitionType,
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formMemo: Record<string, any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  dataFunction: Record<string, Function> | undefined,
  setTimer: Function | undefined,
  locale: string | undefined,
  authDataType: AuthDataType | "info",
  mode: "default" | "result" | "demo" | "beaninfo",
  useDefaultMemo?: boolean,
): DataColumnRecord => {
  const result: DataColumnRecord = {
    ...brewingType(form, formMemo?.current, formFunction, dataFunction, locale, authDataType, mode),
    blending_loss_set: {
      label: "loss_rate",
      itemClassName: "brewing_result",
      edit: { display: mode === "result" ? true : false },
      read: { display: mode === "result" ? "notNull" : false, displayCheckIds: ["blending_loss", "blending_organic_loss"] },
      fieldId: {
        blending_loss: {
          ...dc.lossRate,
          variant: "outlined",
          tooltip: "loss_rate",
          inputClassName: dc.inputNumberClassName + " text-last brewing_result",
          read: { display: "notNull", displayCheckIds: undefined },
        },
        blending_organic_loss: {
          ...dc.lossRate,
          variant: "outlined",
          inputClassName: dc.inputNumberClassName + " text-last brewing_result",
          placeholder: "organic_loss",
          tooltip: "organic_loss",
          read: { display: "notNull", displayCheckIds: undefined },
        },
      },
    },
    ...brewingCommon(t, form, formMemo, formFunction, dataFunction, locale, authDataType, mode === "result", setTimer, mode),
    brewing_summary_1: {
      label: "summary_label",
      labelClassName: dc.strongLabelClassName + " " + dc.mobileHidden,
      itemClassName: "brewing_result",
      edit: { display: false },
      display: authDataType === "info" ? false : undefined,
      inputType: "summary",
      fieldId: {
        brewing_term: {
          ...dc.secondTimer(locale),
          prev: { element: "brewing_step_time", transition: true },
          unitPrev: " - ",
        },
        brewing_mass: { ...dc.mass, prev: { element: "brewing_mass", transition: true }, unitPrev: " - " },
        brewing_type: { ...dc.select, prev: { element: "brewing_type", transition: true }, unitPrev: " - ", codeGroup: "EXTR" },
        brewing_bar: { ...dc.bar, prev: { element: "brewing_bar", transition: true }, unitPrev: " : " },
        brewing_temp: { ...dc.temp, prev: { element: "brewing_temp", transition: true }, unitPrev: " : " },
        blending_loss: { ...dc.percent, prev: { element: "loss_rate", transition: true }, unitPrev: " : " },
      },
      // itemClassName: "whitespace-pre-wrap text-start",
      valueJoin: ", ",
    },
    brewing_summary_2: {
      label: "blank",
      labelClassName: dc.strongLabelClassName + " " + dc.mobileHidden,
      itemClassName: "brewing_result",
      edit: { display: false },
      read: { display: authDataType === "info" ? false : { brewing_step_use: 1 } },
      inputType: "summary",
      fieldId: {
        brewing_step1_term: { ...dc.secondTimer(locale), unitPrev: "" },
        brewing_step1_mass: { ...dc.mass, unitPrev: " - " },
        brewing_step2_term: { ...dc.secondTimer(locale), unitPrev: " | " },
        brewing_step2_mass: { ...dc.mass, unitPrev: " - " },
        brewing_step3_term: { ...dc.secondTimer(locale), unitPrev: " | " },
        brewing_step3_mass: { ...dc.mass, unitPrev: " - " },
        brewing_step4_term: { ...dc.secondTimer(locale), unitPrev: " | " },
        brewing_step4_mass: { ...dc.mass, unitPrev: " - " },
        brewing_step5_term: { ...dc.secondTimer(locale), unitPrev: " | " },
        brewing_step5_mass: { ...dc.mass, unitPrev: " - " },
        brewing_step6_term: { ...dc.secondTimer(locale), unitPrev: " | " },
        brewing_step6_mass: { ...dc.mass, unitPrev: " - " },
        brewing_step7_term: { ...dc.secondTimer(locale), unitPrev: " | " },
        brewing_step7_mass: { ...dc.mass, unitPrev: " - " },
        brewing_step8_term: { ...dc.secondTimer(locale), unitPrev: " | " },
        brewing_step8_mass: { ...dc.mass, unitPrev: " - " },
        brewing_step9_term: { ...dc.secondTimer(locale), unitPrev: " | " },
        brewing_step9_mass: { ...dc.mass, unitPrev: " - " },
      },
      valueJoin: "",
    },
  };
  if (useDefaultMemo ?? true) {
    return { ...result, brewing_default_memo: { ...dc.textAreaM } };
  } else {
    return result;
  }
};
